export default {
    name: 'NotificationDetailsAnon',
    template: '#cmp-notification-anon',
    data() {
        return {
            guid: '',
            language: 'en-us',
            notification: null,
            showContent: false,
            showError: false,
            showError404: false,
            submitting: true
        };
    },
    methods: {
        getNotification() {
            let self = this;
            $.getJSON('/api/notifications/' + self.guid)
                .done((r) => {
                    self.submitting = false;
                    self.showContent = true;
                    self.language = r.language;
                    self.getNotificationContent(r.notification.content);
                })
                .fail((e) => {
                    if (e.status === 404) {
                        self.showError404 = true;
                    } else {
                        self.showError = true;
                    }
                    self.submitting = false;
                });
        },
        getNotificationContent(notifications) {
            let self = this;
            let content;

            notifications.forEach((c) => {
                if (c.locale === self.language) {
                    content = c;
                }
            });

            if (!content) {
                notifications.forEach((c) => {
                    if (c.locale === 'en-us') {
                        content = c;
                    }
                });
            }

            if (!content) {
                content = notifications[0];
            }

            self.notification = content;
        }
    },
    created() {
        this.guid = this.$route.params.guid;
        this.getNotification();
    }
}


// WEBPACK FOOTER //
// ./src/scripts/vue/components/NotificationAnon.js